import React from "react";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";
import { AiAnswerSourceItem } from "./aiAnswerMetadata.types";
import { localizeFormatString } from "../SupplierAiAgent/hooks/useLocalizer";

interface AIAnswerMetadataSourcesProps {
    localizer: IStringLocalizer;
    sources: AiAnswerSourceItem[];
}

const AIAnswerMetadataSources: React.FC<AIAnswerMetadataSourcesProps> = ({
    localizer,
    sources
}) => {
    if (sources.length === 0) {
        return null;
    }

    return (
        <div className="ai-answer-field__details-section ai-answer-field__details-section--sources">
            <p className="ai-answer-field__section-title">{localizer.localizeString("Source:")}</p>
            <div className="ai-answer-field__source-list">
                {sources.map((source, sourceIndex) =>
                    <div className="ai-answer-field__source-row" key={`${source.document}-${sourceIndex}`}>
                        <p className="ai-answer-field__source-document">
                            {source.document}
                            {source.pageNumber !== undefined ? ` - ${localizeFormatString(localizer, "Page {0}", source.pageNumber)}` : ""}
                        </p>
                        {source.content &&
                            <p className="ai-answer-field__source-content">"{source.content}"</p>
                        }
                    </div>
                )}
            </div>
        </div>
    );
};

export default AIAnswerMetadataSources;
